import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
      id: 'admanagementindex.title',
      defaultMessage: 'Ad Management Index',
  }
});